import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { API_BASE } from '../../lib/utils';
import { toast } from 'sonner';

const Pipeline = () => {
  const { user } = useAuth();
  const [pipeline, setPipeline] = useState({ new: [], shortlisted: [], interview: [], offer: [], accepted: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPipeline();
  }, []);

  const fetchPipeline = async () => {
    try {
      const response = await axios.get(`${API_BASE}/pipeline/${user.id}`);
      setPipeline(response.data);
    } catch (error) {
      console.error('Failed to fetch pipeline:', error);
    } finally {
      setLoading(false);
    }
  };

  const moveCandidate = async (matchId, newStatus) => {
    try {
      await axios.put(`${API_BASE}/pipeline/update`, { match_id: matchId, new_status: newStatus });
      toast.success('Pipeline updated');
      fetchPipeline();
    } catch (error) {
      toast.error('Failed to update pipeline');
    }
  };

  if (loading) {
    return <div className="p-8 flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0D9488]"></div></div>;
  }

  const stages = [
    { key: 'new', label: 'New', color: 'bg-slate-100' },
    { key: 'shortlisted', label: 'Shortlisted', color: 'bg-blue-100' },
    { key: 'interview', label: 'Interview', color: 'bg-purple-100' },
    { key: 'offer', label: 'Offer', color: 'bg-orange-100' },
    { key: 'accepted', label: 'Accepted', color: 'bg-green-100' }
  ];

  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>Recruitment Pipeline</h1>

        <div className="grid grid-cols-5 gap-4">
          {stages.map((stage) => (
            <div key={stage.key} className="bg-white border border-slate-200 rounded-2xl p-4">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold">{stage.label}</h3>
                <span className="text-sm text-slate-500">{pipeline[stage.key]?.length || 0}</span>
              </div>
              <div className="space-y-2">
                {pipeline[stage.key]?.map((match) => (
                  <div
                    key={match.id}
                    className={`${stage.color} p-3 rounded-lg cursor-move`}
                    draggable
                    data-testid={`pipeline-card-${match.id}`}
                  >
                    <div className="font-medium text-sm">{match.apprentice_name}</div>
                    <div className="text-xs text-slate-600">{match.role_title}</div>
                    <div className="text-xs text-slate-500 mt-1">{match.match_score}% match</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pipeline;
